var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLPpaymentsonappicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65583",
    "data-name": "Grupo 65583",
    transform: "translate(-792 -1220)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_15499",
    "data-name": "Ret\\xE2ngulo 15499",
    transform: "translate(792 1220)",
    fill: "none",
    stroke: "#e0e0e0",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65549",
    "data-name": "Grupo 65549",
    transform: "translate(3814 6993.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95623",
    "data-name": "Caminho 95623",
    d: "M412.06,650.23a1,1,0,0,1-.94-.94,3.361,3.361,0,0,0-3.35-3.37H407a3.372,3.372,0,0,0-3.36,3.37.94.94,0,1,1-1.87,0,5.251,5.251,0,0,1,5.23-5.25h.79a5.251,5.251,0,0,1,5.21,5.25.939.939,0,0,1-.94.94Zm-12.18-.94a1,1,0,0,0-.94-.94h-4.32a3.749,3.749,0,0,1-3.74-3.74V631.85a3.749,3.749,0,0,1,3.74-3.74h8.63a3.751,3.751,0,0,1,3.75,3.74.94.94,0,1,0,1.88,0,5.63,5.63,0,0,0-5.63-5.62h-8.63a5.62,5.62,0,0,0-5.62,5.62v12.76a5.62,5.62,0,0,0,5.62,5.62h4.32a1,1,0,0,0,.94-.94Zm3.42-16a.939.939,0,0,0-.94-.94h-6.94a.94.94,0,1,0,0,1.88h6.94a.941.941,0,0,0,.94-1Zm-1.88,7.17a.941.941,0,0,0-.94-.93h-5.06a.94.94,0,1,0,0,1.87h5.06a.938.938,0,0,0,.877-.6.932.932,0,0,0,.063-.369Z",
    transform: "translate(-3399 -6387.99)",
    fill: "#142249"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95624",
    "data-name": "Caminho 95624",
    d: "M401.42,636.87a.939.939,0,0,0-.94-.94h-5.06a.94.94,0,1,0,0,1.88h5.06a.947.947,0,0,0,.36-.071.966.966,0,0,0,.3-.2.936.936,0,0,0,.2-.3A.925.925,0,0,0,401.42,636.87Z",
    transform: "translate(-3399 -6387.99)",
    fill: "#38d2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95625",
    "data-name": "Caminho 95625",
    d: "M401.42,644.04a.916.916,0,0,0-.072-.358.905.905,0,0,0-.2-.3.915.915,0,0,0-.305-.2.94.94,0,0,0-.359-.068h-5.06a.94.94,0,1,0,0,1.87h5.06a.939.939,0,0,0,.94-.94Z",
    transform: "translate(-3399 -6387.99)",
    fill: "#38d2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95626",
    "data-name": "Caminho 95626",
    d: "M407.33,634.67a4,4,0,1,0,2.828,1.171A4,4,0,0,0,407.33,634.67Zm0,6.09a2.11,2.11,0,1,1,1.492-.618A2.109,2.109,0,0,1,407.33,640.76Z",
    transform: "translate(-3399 -6387.99)",
    fill: "#38d2d9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLPpaymentsonappicon);
export default __webpack_public_path__ + "static/media/LPpaymentsonappicon.47010a0810ac68869d9f43cfc25748e8.svg";
export { ForwardRef as ReactComponent };